import { useTranslation } from "@i18n";
import stl from "./LessThanMarket.module.css";

const LessThanMarket = ({ lowMileage }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={stl.ContlesThan}>
        <span>{lowMileage?.pre_text}</span>
        <strong> {lowMileage?.value_text}</strong>
        <span>
          {t("كم في السنة", {
            ns: "web_post_view",
          })}
        </span>
      </div>
    </>
  );
};

export default LessThanMarket;
